import { SecondHandSuppliesOrders } from './../../models/second-hand-supplies-orders';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastService } from 'src/app/core/toast.service';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { RefundOrderService } from '../../services/refund-order.service';
@Component({
  selector: 'app-refund-order',
  templateUrl: './refund-order.component.html',
  styleUrls: ['./refund-order.component.scss']
})
export class RefundOrderComponent implements OnInit {
  /* --------------------------- change status form --------------------------- */
  refundForm = this.fb.group({
    amount : [null, [Validators.required]],
    payment_intent_id : [null, [Validators.required]],
    second_hand_supplies_order_id : [null, [Validators.required]]
  });
  refundedAmount: number = 0;
  refundRemaining:number = 0;
  /* ------------------------------- Constructor ------------------------------ */
  constructor(
    private fb: FormBuilder,
    private _dialogRef: MatDialogRef<RefundOrderComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SecondHandSuppliesOrders,
    private toast: ToastService,
    private spinner: NgxSpinnerService,
    private refundOrderService: RefundOrderService
  ) { }
/* ---------------------------- Life cycle hooks ---------------------------- */
  ngOnInit(): void {
    if(this.data.refunds && this.data.refunds.length){
      this.refundedAmount = this.data.refunds.reduce((previousValue: number, currentValue: any)=>{
        return previousValue + currentValue.amount;
      }, 0);
    }
    this.refundRemaining = this.data.total_amount - this.refundedAmount;
    this.payment_intent_id.setValue(this.data.payment_intent.id);
    this.second_hand_supplies_order_id.setValue(this.data.id);
    this.amount.setValue(this.refundRemaining);
    this.amount.setValidators([Validators.required, Validators.max(this.refundRemaining)])
  }

  /* ---------------------------- Custom Functions ---------------------------- */
  dialogClose(status: string) {
    // this._dialogRef.close(status);
    document.getElementsByClassName("animate__animated")[0].classList.remove("animate__fadeInDown")
    document.getElementsByClassName("animate__animated")[0].classList.add("animate__fadeOutUp");
    setTimeout(() => { this._dialogRef.close(status); }, 1000);
  }

  /* --------------------------------- Getters -------------------------------- */
  get amount(){
    return this.refundForm.get('amount');
  }
  get payment_intent_id(){
    return this.refundForm.get('payment_intent_id');
  }
  get second_hand_supplies_order_id(){
    return this.refundForm.get('second_hand_supplies_order_id');
  }
  async refundOrder(){
    if(this.refundForm.invalid){
      this.toast.openSnackBar('Please enter valid details');
      return;
    }
    this.spinner.show();
    try {
      await this.refundOrderService.refundOrder( this.refundForm.value );
        this.spinner.hide();
        this.toast.openSnackBar('Order refunded successfully');
        this.dialogClose('yes');
    } catch(error) {
      this.spinner.hide();
       this.toast.openSnackBar('Unable to refund order');
    }
  }
}


